import { NotificationType } from '@shared/types/Notification';
import pushNotification from '@shared/utils/notification';
import { useI18n } from 'vue-i18n';

export const useCopy = () => {
  const { t } = useI18n();

  const copy = async ({
    value,
    successMessage
  }: {
    value: string;
    successMessage?: string;
  }) => {
    try {
      await navigator.clipboard.writeText(value);
      pushNotification({
        type: NotificationType.SUCCESS,
        message:
          successMessage ||
          t('common_messages.success.copied_to_clipboard', { text: value })
      });
    } catch (error) {
      pushNotification({
        type: NotificationType.DANGER,
        message: t('common_messages.error.copied_to_clipboard_failed')
      });
    }
  };

  return { copy };
};
